import script from "./StreakBonusBar.vue?vue&type=script&setup=true&lang=js"
export * from "./StreakBonusBar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__